export const stripeSupportedCountries = [
  { code: "US", country: "United States" },
  { code: "CA", country: "Canada" },
  { code: "GB", country: "United Kingdom" },
  { code: "AU", country: "Australia" },
  { code: "DE", country: "Germany" },
  { code: "FR", country: "France" },
  { code: "IT", country: "Italy" },
  { code: "ES", country: "Spain" },
  { code: "NL", country: "Netherlands" },
  { code: "BE", country: "Belgium" },
  { code: "AT", country: "Austria" },
  { code: "CH", country: "Switzerland" },
  { code: "SE", country: "Sweden" },
  { code: "NO", country: "Norway" },
  { code: "DK", country: "Denmark" },
  { code: "FI", country: "Finland" },
  { code: "IE", country: "Ireland" },
  { code: "PT", country: "Portugal" },
  { code: "LU", country: "Luxembourg" },
  { code: "JP", country: "Japan" },
  { code: "SG", country: "Singapore" },
  { code: "HK", country: "Hong Kong" },
  { code: "NZ", country: "New Zealand" },
];
